import DocumentIcon from '@/common/assets/icons/document.svg?react';
import NoteIcon from '@/common/assets/icons/note.svg?react';
import LoadingPage from '@/common/pages/LoadingPage';
import LabelBox from '@/modules/FileDetail/components/statusTransition/LabelBox.tsx';
import { fileEntryQueryOptions } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryOptions.ts';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { HStack } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const SummeryFile = () => {
  const { id } = useParams();
  const { data, isError, isPending } = useQuery(fileEntryQueryOptions(id!));

  if (isError) {
    return <></>;
  }

  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <>
      <HStack>
        <LabelBox>
          <DocumentIcon />
          <span dir="ltr">{data?.order_id} پرونده </span>
        </LabelBox>
        <LabelBox>
          <NoteIcon stroke={token('colors.purple-1')} />
          {data?.status?.fa_const}
        </LabelBox>
      </HStack>
    </>
  );
};
export default SummeryFile;
